import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ledgerSearchSchema } from '@/features/collections';

export const Route = createFileRoute('/_app/collections')({
  validateSearch: ledgerSearchSchema,
  staticData: { crumb: 'nav.collections', crumbTo: '/collections' },
  beforeLoad: ({ context }) =>
    requirePermission(context.queryClient, 'collection.view', 'Collections'),
  component: Outlet,
});
